import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, renderSlot as _renderSlot, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "menu-scroll"
};
const _hoisted_2 = {
  class: "sidebar-footer text-center py-2"
};
const _hoisted_3 = ["src"];
const _hoisted_4 = {
  class: "text-truncate",
  style: {
    "max-width": "55px",
    "margin": "auto"
  }
};
const _hoisted_5 = {
  style: {
    "min-height": "100%"
  }
};
import NavBarComp from '@/components/nav-bar.vue';
import usePlanPrice from '@/composable/plan-price';
export default {
  __name: 'Admin',
  setup(__props) {
    const {
      tenantInfo
    } = usePlanPrice();
    function goToExternalSite() {
      if (tenantInfo?.value?.website) {
        window.open(tenantInfo.value.website, '_blank');
      }
    }
    return (_ctx, _cache) => {
      const _component_b_card = _resolveComponent("b-card");
      const _component_el_header = _resolveComponent("el-header");
      const _component_Menu = _resolveComponent("Menu");
      const _component_el_scrollbar = _resolveComponent("el-scrollbar");
      const _component_el_tooltip = _resolveComponent("el-tooltip");
      const _component_el_aside = _resolveComponent("el-aside");
      const _component_el_main = _resolveComponent("el-main");
      const _component_el_container = _resolveComponent("el-container");
      return _openBlock(), _createBlock(_component_el_container, {
        class: "layout-container-demo"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_header, {
          class: "shadow-lg d-print-none",
          style: {
            "padding": "0",
            "height": "70px"
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_b_card, {
            class: "p-0 m-0",
            "no-body": ""
          }, {
            default: _withCtx(() => [_createVNode(NavBarComp)]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_container, null, {
          default: _withCtx(() => [_createVNode(_component_el_aside, {
            class: "shadow-lg d-print-none sidebar",
            width: "auto"
          }, {
            default: _withCtx(() => [_createVNode(_component_b_card, {
              class: "p-0 m-0 h-100 d-flex flex-column",
              "no-body": ""
            }, {
              default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createVNode(_component_el_scrollbar, null, {
                default: _withCtx(() => [_createVNode(_component_Menu)]),
                _: 1
              })]), _createElementVNode("div", _hoisted_2, [_createElementVNode("span", {
                class: "logo-lg",
                style: {
                  "cursor": "pointer"
                },
                onClick: goToExternalSite
              }, [_createElementVNode("img", {
                src: _unref(tenantInfo)?.logo ?? '',
                class: "img-thumbnail shadow",
                width: "40"
              }, null, 8, _hoisted_3)]), _createVNode(_component_el_tooltip, {
                content: _unref(tenantInfo)?.tenant_name,
                effect: "light",
                placement: "top"
              }, {
                default: _withCtx(() => [_createElementVNode("div", {
                  class: "text-center",
                  style: {
                    "cursor": "pointer"
                  },
                  onClick: goToExternalSite
                }, [_createElementVNode("div", _hoisted_4, _toDisplayString(_unref(tenantInfo)?.tenant_name), 1)])]),
                _: 1
              }, 8, ["content"])])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_main, {
            class: "main-scroll"
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_5, [_renderSlot(_ctx.$slots, "default")])]),
            _: 3
          })]),
          _: 3
        })]),
        _: 3
      });
    };
  }
};